import React from "react";
import MainLayout from "../layouts/MainLayout";
import FormBuilderPage from "../pages/FormBuilderPage";
import TemplatesPage from "../pages/TemplatesPage";
import Error404 from "../pages/Error404";
import UserResponsePage from "../pages/UserResponsePage";
import PublishTemplateListPage from "../pages/PublishTemplateListPage";
import UserFormBuilderPage from "../pages/UserFormBuilderPage";
import Login from "../login/Login";
import ProtectedRoute from "./ProtectedRoute";
import UserListPage from "../pages/UserListPage";
import ResponseListPage from "../pages/ResponseListPage";
import CreateUser from "../pages/CreateUser";
import UpdateUser from "../pages/UpdateUser";
import ViewUser from "../pages/ViewUser";
import Testing from "../components/Testing";
import Test2 from "../components/Test2";

// Teacher Components
import TeacherLogin from "../pages/TeacherLogin";
import TeacherLayout from "../layouts/TeacherLayout";
import TeacherDashboard from "../pages/TeacherDashboard";
import PrintPage from "../pages/PrintPage";
import VerifyIdCard from "../pages/VerifyIdCard";
import { Navigate } from "react-router-dom";

// Protected Teacher Route
const ProtectedTeacherRoute = ({ children }) => {
  const token = localStorage.getItem("schoolId");
  if (!token) return <Navigate to="/teacher-login" />;
  return children;
};

const routes = [
  {
    path: "/",
    element: <Login />,
    errorElement: <Error404 />,
  },
  {
    children: [
      // Main App routes
      {
        path: "main-layout",
        element: (
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        ),
      },
      {
        path: "teacher-login",
        element: <TeacherLogin />,
      },

      // Teacher Panel (Protected)
      {
        path: "teacher",
        element: (
          <ProtectedTeacherRoute>
            <TeacherLayout />
          </ProtectedTeacherRoute>
        ),
        children: [
          {
            path: "dashboard",
            element: <TeacherDashboard />,
          },
          {
            path: "print",
            element: <PrintPage />,
          },
          {
            path: "edit-id-card",
            element: <VerifyIdCard />,
          },
        ],
      },

      // User Form
      {
        path: "user-form/:formId/:name",
        element: <UserFormBuilderPage />,
      },
      {
        path: "publish-template",
        element: <PublishTemplateListPage />,
      },
      // User routes
      {
        path: "user-list",
        element: <UserListPage />,
      },
      {
        path: "create-user",
        element: <CreateUser />,
      },
      {
        path: "update-user/:userId",
        element: <UpdateUser />,
      },
      {
        path: "view-user/:userId",
        element: <ViewUser />,
      },
      // Responses
      {
        path: "user-insights",
        element: <UserResponsePage />,
      },
      {
        path: "form-builder/:formId",
        element: <FormBuilderPage />,
      },
      {
        path: "templates-page",
        element: <TemplatesPage />,
      },
      {
        path: "user-responses/:formId",
        element: <ResponseListPage />,
      },
    ],
  },
];

export default routes;
